import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { deleteCropMixComposerSettings } from "services";

import { DELETE_CROP_MIX_COMPOSER_SETTINGS, GET_CROP_MIX_COMPOSER_SETTINGS } from "consts";

export const useDeleteCropMixComposerSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_CROP_MIX_COMPOSER_SETTINGS],
    mutationFn: deleteCropMixComposerSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_MIX_COMPOSER_SETTINGS] });
    },
    onError: (err) => {
      if (err instanceof AxiosError && err.response?.status === 404) {
        return Promise.resolve({ success: false });
      }
      return Promise.reject(err);
    },
  });
};
